import { render, staticRenderFns } from "./Exhibitors.vue?vue&type=template&id=0f7fd82b&scoped=true&"
import script from "./Exhibitors.vue?vue&type=script&lang=js&"
export * from "./Exhibitors.vue?vue&type=script&lang=js&"
import style0 from "./Exhibitors.vue?vue&type=style&index=0&id=0f7fd82b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7fd82b",
  null
  
)

export default component.exports